import gql from '@lib/gql'
import useSentry from '@hooks/useSentry'
interface Variables {
  [key: string]: string | number | boolean
}

interface Body {
  query: string,
  variables?: Variables
}

interface Headers {
  Authorization?: string
}

const useMutation = <Data extends unknown>(query: string, headers: Headers = {}) => {
  const { captureException } = useSentry()

  const mutate = async function (variables?: Variables, additionalHeaders: Headers = {}) {
    let error: Maybe<unknown>
    let data: Maybe<Data>

    const body: Body = { query }
    if (variables) body.variables = variables

    try {
      const response = await gql.post('', body, { headers: { ...headers, ...additionalHeaders } })
      error = response.data.error
      data = response.data.data
    } catch (err: unknown) {
      error = err
    }

    if (error) captureException(error)

    return { data, error }
  }

  return { mutate }
}

export default useMutation
